import React from 'react';
import { motion } from 'framer-motion';
import { PenTool, Link, Rocket } from 'lucide-react';
const steps = [{
  icon: PenTool,
  title: 'Map Your Flow',
  description: 'Sketch your process on the Cascade Builder canvas. Drag nodes, set conditions.'
}, {
  icon: Link,
  title: 'Wire Your Tools',
  description: 'Connect apps through Nexus Connectors. Authenticate once, use everywhere.'
}, {
  icon: Rocket,
  title: 'Launch & Monitor',
  description: 'Activate your workflow. Watch it run on the Meridian Dashboard in real-time.'
}];
export function HowItWorksSection() {
  return <section id="how-it-works" className="py-24 bg-white overflow-hidden" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="text-center mb-20" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-158">
            From Idea to Automation in Minutes
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-159">
            No coding required. Just logical thinking and a few clicks.
          </p>
        </div>

        <div className="relative grid md:grid-cols-3 gap-12" data-id="element-160">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 w-full h-0.5 bg-slate-100 -z-10" data-id="element-161">
            <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-transparent via-sky-200 to-transparent opacity-50" data-id="element-162"></div>
          </div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center" data-id="element-163">
              {/* Step Number Badge */}
              <div className="absolute -top-4 bg-white px-2 text-sm font-bold text-sky-500" data-id="element-164">
                Step 0{index + 1}
              </div>

              <div className="w-24 h-24 bg-white rounded-full border-4 border-sky-50 flex items-center justify-center text-sky-500 mb-6 shadow-sm z-10 relative" data-id="element-165">
                <step.icon size={32} data-id="element-166" />
                {/* Node dots on circle */}
                <div className="absolute top-1/2 -right-1 w-2 h-2 bg-sky-300 rounded-full" data-id="element-167"></div>
                <div className="absolute top-1/2 -left-1 w-2 h-2 bg-sky-300 rounded-full" data-id="element-168"></div>
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-169">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed max-w-xs" data-id="element-170">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}